export const classSelectors = {
  component: "react-select-tags",

  mainWrapper: "mainWrapper",

  inputWrapper: "inputWrapper",

  tags: "tags",

  expander: "expander",
  input: "input",
  inputInvalid: "invalid",

  options: "options",
  optionsWrapper: "optionsWrapper",
  filter: "filter",

  loader: "loader",
  spinner: "spinner",

  message: "message",
  group: "group",
  option: "option",

  tag: "tag",
  tagReadOnly: "readonly",
  tagLocked: "locked",
  tagInvalid: "invalid",
  tagWrapper: "tagWrapper",
  contentWrapper: "contentWrapper",
  tagContent: "content",
  tagRemove: "remove",
};
